import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export interface SearchFilterExpandableClasses {
	/** Styles applied to the root element. */
	root: string;
	expanded: string;
}

export const getSearchFilterExpandableUtilityClass = (slot: string) =>
	generateUtilityClass('SearchFilterExpandable', slot);

export const searchFilterExpandableClasses = generateUtilityClasses(
	'SearchFilterExpandable',
	['root', 'expanded'],
);
export default searchFilterExpandableClasses;
